export default __webpack_public_path__ + "static/media/Como-crear-una-caratula-e-indice-con-Word.ed2ebbe9.jpg";